<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-12.mb-1
        DateRangePicker(:value="dateRange" @update="getData")
      .form-group.col-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getLogList(true)"
          variant="primary"
          size="sm"
        )
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)")
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="5%")
                  span #
                th(width="10%" @click="sortOrder('result_id')")
                  span(:title="$t('ui.result_id')") {{ $t('ui.result_id') }}
                  .float-right
                    i(:class="changeSortKey('result_id')")
                th(width="15%" @click="sortOrder('bet_time')")
                  span(:title="$t('ui.bet_time')") {{ $t('ui.bet_time') }}
                  .float-right
                    i(:class="changeSortKey('bet_time')")
                th(width="10%" @click="sortOrder('member_id')")
                  span(:title="$t('ui.member_id')") {{ $t('ui.member_id') }}
                  .float-right
                    i(:class="changeSortKey('member_id')")
                th.text-right(width="10%" @click="sortOrder('turnover')")
                  span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                  .float-right
                    i(:class="changeSortKey('turnover')")
                th.text-right(width="10%" @click="sortOrder('payout')")
                  span(:title="$t('ui.payout')") {{ $t('ui.payout') }}
                  .float-right
                    i(:class="changeSortKey('payout')")
                th.text-right(width="10%" @click="sortOrder('winlose')")
                  span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                  .float-right
                    i(:class="changeSortKey('winlose')")
                th(width="10%" @click="sortOrder('provider_name')")
                  span(:title="$t('ui.provider_name')") {{ $t("ui.provider_name") }}
                  .float-right
                    i(:class="changeSortKey('provider_name')")
                th(width="15%" @click="sortOrder('created_on')")
                  span(:title="$t('ui.created_on')") {{ $t("ui.created_on") }}
                  .float-right
                    i(:class="changeSortKey('created_on')")
                th(width="5%")
            tbody.clusterize-content
              tr(v-if="logList.length == 0")
                td(colspan="10").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in logList")
                td.text-center
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  span(:title="item.result_id") {{ item.result_id }}
                td
                  span(:title="$moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss') }}
                td
                  span(:title="item.member_id") {{ item.member_id }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.payout)" :title="$n(item.payout, 'currency')") {{ $n(item.payout, 'currency') }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                td
                  span(:title="item.provider_name") {{ item.provider_name }}
                td
                  span(:title="$moment(item.created_on).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_on).format('YYYY-MM-DD, HH:mm:ss') }}
                td.text-center
                  span
                    a.fa.fa-eye.text-secondary(href="javascript:void(0)" @click="onViewDetail(item)" :title="$t('ui.view_detail')")
      viewresultchangesdetail(ref="viewresultchangesdetail" :item="selectedResult" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import viewresultchangesdetail from "@/components/log/viewResultChangesDetail.vue";
import jsonToExcel from "@/library/jsonToExcel.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    viewresultchangesdetail,
    jsonToExcel
  },
  props: {
    currTab: {
      type: String,
      default: ''
    },
    operatorID: {
      type: String,
      default: ''
    },
    memberID: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    loading: false,
    logList: [],
    currentPage: 1,
    totalRow: 0,
    selectedResult: null,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null,
    },
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    sortKey: "bet_time",
    sortType: "desc"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeMemberLog;
    }
  },
  mounted: function() {},
  destroyed: function() {
    var json = {
      start_date: null,
      end_date: null
    };
    this.$store.dispatch("user/setResultChangesLogParam", json);
  },
  methods: {
    refresh() {
      if (this.$store.getters.resultChangesLog.start_date && this.$store.getters.resultChangesLog.end_date) {
        this.dateRange.startDate = this.$store.getters.resultChangesLog.start_date;
        this.dateRange.endDate = this.$store.getters.resultChangesLog.end_date;
      } else {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      }

      this.getLogList(true);
    },
    setResultChangesLogParam: function() {
      var json = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };
      this.$store.dispatch("user/setResultChangesLogParam", json);
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getLogList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getLogList(true);
    },
    onViewDetail(e) {
      this.selectedResult = e;
      this.$refs.viewresultchangesdetail.$refs.viewResultChangesDetail.show();
    },
    getLogList: function(isSearch) {
      if (this.checkDateRange()) {

        let url = config.gameResultChangesUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          member_id: this.memberID,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.logList = response.data.dt;
                  this.totalRow = this.logList.length > 0 ? this.logList[0].totalrows : 0;
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.logList = [];
        this.totalRow = 0;
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    changedPageSize: function(pageSize) {
      if(this.currTab != 'resultchangeslog') return
      this.$store.dispatch("layout/setPageSizeMemberLog", pageSize);
      this.currentPage = 1;
      this.getLogList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getLogList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>